import { motion } from 'motion/react'
import { useEffect, useState } from 'react'
import { cn } from '#app/lib/utils'

interface BlockRotatingTextProps {
	domains: string[]
	duration?: number
	className?: string
}

export function BlockRotatingText({
	domains,
	duration = 4000,
	className,
}: BlockRotatingTextProps) {
	const [index, setIndex] = useState(0)

	useEffect(() => {
		const interval = setInterval(() => {
			setIndex((prevIndex) => (prevIndex + 1) % domains.length)
		}, duration)

		return () => clearInterval(interval)
	}, [domains, duration])

	return (
		<h1 className={cn('overflow-hidden py-2 text-center', className)}>
			<div>
				<span>Block </span>
				<span className="inline-grid">
					{domains.map((domain, i) => (
						<motion.span
							key={domain}
							className={cn(
								'text-primary col-start-1 row-start-1',
								i !== index && 'opacity-0',
							)}
							initial={{
								opacity: i === index ? 1 : 0,
								y: i === index ? 0 : -20,
							}}
							animate={{
								opacity: i === index ? 1 : 0,
								y: i === index ? 0 : -20,
							}}
							transition={{ duration: 0.25, ease: 'easeOut' }}
						>
							{domain}
						</motion.span>
					))}
				</span>
				<span> Distractions,</span>
			</div>
			<div>
				<span>Without Stopping Work.</span>
			</div>
		</h1>
	)
}
